import CUP from '../utils/CUP';
import Logger, {LOG_LEVELS} from '../utils/logger';
import REST_CLIENT from "../utils/restClient";
import { clearAllTokens, getAccessToken, getIdToken } from '../utils/tokenStorage';
import getClientConfig from '../utils/getClientConfig';
import { jwtDecode } from "jwt-decode";
import { parseDirectSubmissionGrants } from '../utils/directSubmissionAccess';

// Same djb2 hash as string-hash@1.1.3, so existing localStorage.uuid values stay valid.
function stringHash(value) {
  let hash = 5381;
  let i = value.length;
  while (i) {
    hash = (hash * 33) ^ value.charCodeAt(--i);
  }
  return hash >>> 0;
}

const MODULE_NAME='AUTHENTICATION_MODULE';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const LOGIN = namespaced('LOGIN');
const LOGIN_OK = namespaced('LOGIN_OK');
const LOGIN_FAIL = namespaced('LOGIN_FAIL');
const AUTHENTICATING = namespaced('AUTHENTICATING');
const AUTHENTICATION_OK = namespaced('AUTHENTICATION_OK');
const AUTHENTICATION_FAIL = namespaced('AUTHENTICATION_FAIL');
const LOGOUT = namespaced('LOGOUT');
const LOGOUT_OK = namespaced('LOGOUT_OK');
const LOGOUT_FAIL = namespaced('LOGOUT_FAIL');
const PRODUCTS = namespaced('PRODUCTS');
const PRODUCTS_OK = namespaced('PRODUCTS_OK');
const PRODUCTS_FAIL = namespaced('PRODUCTS_FAIL');
const MASQUERADING = namespaced('MASQUERADING');
const MASQUERADE_OK = namespaced('MASQUERADE_OK');
const MASQUERADE_FAIL = namespaced('MASQUERADE_FAIL');
const CUSTOMERS = namespaced('CUSTOMERS');
const CUSTOMERS_OK = namespaced('CUSTOMERS_OK');
const CUSTOMERS_FAIL = namespaced('CUSTOMERS_FAIL');
const LICENCES = namespaced('LICENCES');
const LICENCES_OK = namespaced('LICENCES_OK');
const LICENCES_FAIL = namespaced('LICENCES_FAIL');
const USERROLE_LOAD = namespaced('USERROLE_LOAD');
const USERROLE_LOAD_OK = namespaced('USERROLE_LOAD_OK');
const USERROLE_LOAD_FAIL = namespaced('USERROLE_LOAD_FAIL');
const USER_DYNAMIC_MENU_LOAD = namespaced('USER_DYNAMIC_MENU');
const USER_DYNAMIC_MENU_OK = namespaced('USER_DYNAMIC_MENU_OK');
const USER_DYNAMIC_MENU_FAIL = namespaced('USER_DYNAMIC_MENU_FAIL');
const ENTITLEMENTS_LOAD = namespaced('ENTITLEMENTS_LOAD');
const ENTITLEMENTS_OK = namespaced('ENTITLEMENTS_OK');
const ENTITLEMENTS_FAIL = namespaced('ENTITLEMENTS_FAIL');
export const ACTION_TYPES = {
  LOGIN,
  LOGIN_OK,
  LOGIN_FAIL,
  AUTHENTICATING,
  AUTHENTICATION_OK,
  AUTHENTICATION_FAIL,
  LOGOUT,
  LOGOUT_OK,
  LOGOUT_FAIL,
  PRODUCTS,
  PRODUCTS_OK,
  PRODUCTS_FAIL,
  MASQUERADING,
  MASQUERADE_OK,
  MASQUERADE_FAIL,
  CUSTOMERS,
  CUSTOMERS_OK,
  CUSTOMERS_FAIL,
  USERROLE_LOAD,
  USERROLE_LOAD_OK,
  USERROLE_LOAD_FAIL,
  USER_DYNAMIC_MENU_LOAD,
  USER_DYNAMIC_MENU_OK,
  USER_DYNAMIC_MENU_FAIL,
  ENTITLEMENTS_LOAD,
  ENTITLEMENTS_OK,
  ENTITLEMENTS_FAIL
};
// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {loading: false, authenticated: false}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, newState) => {
    switch (action.type) {
      case LOGIN:
      case AUTHENTICATING:
        delete newState.error;
        delete newState.data;
        // Entitlements are per tenant, so they must never survive into another session.
        delete newState.entitlements;
        newState.loading = true;
        newState.authenticated = false;
        return newState;
      case LOGIN_OK:
      case AUTHENTICATION_OK:
        delete newState.error;
        newState.data = action.authenticationInfo;
        newState.loading = false;
        newState.authenticated = true;
        return newState;
      case LOGIN_FAIL:
      case AUTHENTICATION_FAIL:
        newState.error = action.error;
        delete newState.data;
        newState.loading = false;
        newState.authenticated = false;
        return newState;
      case LOGOUT:
        delete newState.error;
        newState.loading = true;
        return newState;
      case LOGOUT_OK:
        delete newState.error;
        delete newState.data;
        delete newState.entitlements;
        newState.loading = true;
        newState.authenticated = false;
        return newState;
      case LOGOUT_FAIL:
        newState.error = action.error;
        delete newState.data;
        delete newState.entitlements;
        newState.loading = true;
        newState.authenticated = false;
        return newState;
      case PRODUCTS:
        return Object.assign({}, state, {loading: true, error: null});
      case PRODUCTS_OK:
        return Object.assign({}, state, {products: action.response || [], loading: false, error: null});
      case PRODUCTS_FAIL:
        return Object.assign({}, state, {products: undefined, loading: false, error: action.error});
        case MASQUERADING:
            log.debug('updateSubStateFromAction: MASQUERADING: ', newState);
            return Object.assign({}, state, {loading: true, error: null});
        case MASQUERADE_OK:
            return Object.assign({}, state, {masqueradeSuccess: true, loading: false, error: null});
        case MASQUERADE_FAIL:
            return Object.assign({}, state, {masqueradeSuccess: false,loading: false, error: action.error});
        case CUSTOMERS:
            return Object.assign({}, state, {loading: true, error: null});
        case CUSTOMERS_OK:
            return Object.assign({}, state, {customer: action.response || [], loading: false, error: null});
        case CUSTOMERS_FAIL:
            return Object.assign({}, state, {customer: undefined, loading: false, error: action.error});
        case LICENCES:
            return Object.assign({}, state, {loading: true, error: null});
        case LICENCES_OK:
            return Object.assign({}, state, {licences: action.response || [], loading: false, error: null});
        case LICENCES_FAIL:
            return Object.assign({}, state, {licences: undefined, loading: false, error: action.error});
        case USERROLE_LOAD:
            return Object.assign({}, state, {loading: true, error: null, userRole: null});
        case USERROLE_LOAD_OK:
          return Object.assign({}, state, {userRole: action.response, loading: false, error: null});
        case USERROLE_LOAD_FAIL:
          return Object.assign({}, state, {userRole: null, loading: false, error: action.error});
        case USER_DYNAMIC_MENU_LOAD:
            return Object.assign({}, state, {loading: true, error: null, dynamicMenuItems: null});
        case USER_DYNAMIC_MENU_OK:
            return Object.assign({}, state, {dynamicMenuItems: action.response, loading: false, error: null});
        case USER_DYNAMIC_MENU_FAIL:
            return Object.assign({}, state, {dynamicMenuItems: null, loading: false, error: action.error});
        case ENTITLEMENTS_LOAD:
            return Object.assign({}, state, {entitlements: {features: {}, loaded: false, error: null}});
        case ENTITLEMENTS_OK:
            return Object.assign({}, state, {entitlements: {features: action.response, loaded: true, error: null}});
        case ENTITLEMENTS_FAIL:
            return Object.assign({}, state, {entitlements: {features: {}, loaded: true, error: action.error}});
        default:
          return newState;
    }
  };
  const newState = getNewState(action, Object.assign({}, state));
  log.debug('updateSubStateFromAction: newState: ', newState);
  return newState;
};

export const API = {
  doAttemptLogin: (username, password, successHandler, failureHandler) => {
    // NOTE: This code does not execute when authenticating with Avalara Identity
    log.debug('doAttemptLogin: ', username, password);
    return (dispatch, getState) => {
      dispatch({type: AUTHENTICATING});
      return CUP.login(username, password)
        .then((authenticationInfo) => {
          log.debug('doAttemptLogin: success response: ', authenticationInfo);
          localStorage.uuid = stringHash(username);
          sessionStorage.token = authenticationInfo.token;
          delete localStorage.masqueradeUser;
          dispatch({type: LOGIN_OK, authenticationInfo });
          if (typeof successHandler === 'function') {
            log.debug('doAttemptLogin: calling successHandler with: ', authenticationInfo);
            successHandler(authenticationInfo);
          }
        })
        .catch((error) => {
          log.debug('doAttemptLogin: failure response: ', error);
          delete localStorage.uuid;
          delete localStorage.mvrCustomerId;
          delete sessionStorage.token;
          dispatch({type: LOGIN_FAIL, error});
          if (typeof failureHandler === 'function') {
            failureHandler(error);
          }
      });
    };
  },
  doAttemptTokenAuthentication: (successHandler, failureHandler) => {
    log.debug('doAttemptTokenAuthentication: ', typeof successHandler, typeof failureHandler);
    return (dispatch, getState) => {
      return CUP.authenticateToken()
        .then((authenticationInfo) => {
          const { enableIamAuth, iamNamespace } = getClientConfig();
          
          log.debug('doAttemptTokenAuthentication: success response', authenticationInfo);
          localStorage.uuid = stringHash(authenticationInfo.userName);
          sessionStorage.token = authenticationInfo.token;
          
          if (enableIamAuth) {
            const token = getAccessToken();
            const payload = jwtDecode(token);
            authenticationInfo.iamData = { organizationId: payload.org, tenantId: payload.tid, userId: payload.uid, userEmail: payload.email, isIamUser: false }

            try {
              const roles = JSON.parse(payload.roles);
              const vatReportingRoles = roles[iamNamespace] || [];
              authenticationInfo.iamData.vatReportingRole = vatReportingRoles[0];
              if (authenticationInfo.iamData.vatReportingRole && authenticationInfo.iamData.vatReportingRole !== '') {
                authenticationInfo.iamData.isIamUser = true;
              }
            }
            catch (error) {
              log.debug('doAttemptTokenAuthentication: error parsing roles', error);
              authenticationInfo.iamData.vatReportingRole = undefined;
            }

            authenticationInfo.iamData.directSubmission = parseDirectSubmissionGrants(payload, iamNamespace);
          }

          dispatch({type: AUTHENTICATION_OK, authenticationInfo });
          log.debug('doAttemptTokenAuthentication: typeof successHandler', typeof successHandler);
          if (typeof successHandler === 'function') {
            log.debug('doAttemptTokenAuthentication: calling successHandler with: ', authenticationInfo);
            successHandler(authenticationInfo);
          }
        })
        .catch((error) => {
          log.debug('doAttemptTokenAuthentication: failure response', error);

          delete sessionStorage.token;
          delete localStorage.mvrCustomerId;
          dispatch({type: AUTHENTICATION_FAIL, error });
          log.debug('doAttemptTokenAuthentication: typeof failureHandler', typeof failureHandler);
          if (typeof failureHandler === 'function') {
            failureHandler(error);
          }

        });

    };
  },
  doAttemptLogout: (successHandler, failureHandler) => {
    log.debug('doAttemptLogout: ');
    return (dispatch) => {
      // Probably should need this to be a promise.
      // Something to look into when we have more time.
      return new Promise((resolve, reject) => {
        try {
          dispatch({ type: LOGOUT });

          const idToken = getIdToken();

          delete sessionStorage.token;
          delete localStorage.mvrCustomerId;
          delete localStorage.masqueradeUser;

          sessionStorage.clear();
          sessionStorage.removeItem('code_verifier');
          sessionStorage.removeItem('auth_state');

          clearAllTokens();

          dispatch({ type: LOGOUT_OK });
          if (typeof successHandler === 'function') {
            successHandler(idToken);
          }
          resolve();
        } catch (error) {
          log.debug('doAttemptLogout: failed response: ', error);
          dispatch({ type: LOGOUT_FAIL, error });
          if (typeof failureHandler === 'function') {
            failureHandler(error);
          }
          reject(error);
        }
      });
    };
  },
  doGetProducts: (username, successHandler, failureHandler) => {
    log.debug('doGetProducts()');
    return (dispatch, state) => {
      dispatch({type: PRODUCTS });
      return CUP.getProducts()
      .then((response) => {
        log.debug('doGetProducts(): response: ', response);
        dispatch({type: PRODUCTS_OK, response: response });
        if (typeof successHandler === 'function') {
          successHandler(response);
        }
      }).catch((error) => {
        log.debug('doGetProducts(): error: ', error);
        dispatch({type: PRODUCTS_FAIL, error: error });
        if (typeof failureHandler === 'function') {
          failureHandler(error);
        }
      });
    };
  },
    doGetCustomers: (successHandler, failureHandler) => {
        log.debug('doGetCustomers()');
        return (dispatch, state) => {
            dispatch({type: CUSTOMERS });
            return CUP.getCustomers()
                .then((response) => {
                    log.debug('doGetCustomers(): response: ', response);
                    dispatch({type: CUSTOMERS_OK, response: response });
                    if (typeof successHandler === 'function') {
                        successHandler(response);
                    }
                }).catch((error) => {
                    log.debug('doGetCustomers(): error: ', error);
                    dispatch({type: CUSTOMERS_FAIL, error: error });
                    if (typeof failureHandler === 'function') {
                        failureHandler(error);
                    }
                });
        };
    },
    doAttemptMasquerade: (accountid, licenseKey,successHandler,failureHandler) => {
        log.debug('doAttemptMasquerade: ', accountid, licenseKey);
        return (dispatch, getState) => {
            dispatch({type: MASQUERADING});
            return CUP.masquerade(accountid, licenseKey)
                .then((authenticationInfo) => {
                    log.debug('doAttemptMasquerade: success response: ', authenticationInfo);
                    localStorage.uuid = authenticationInfo.userName;
                    sessionStorage.token = authenticationInfo.token;
                    localStorage.masqueradeUser = true;
                    dispatch({type: MASQUERADE_OK, authenticationInfo });
                    dispatch({type: LOGIN_OK, authenticationInfo });
                    if (typeof successHandler === 'function') {
                        log.debug('doAttemptMasquerade: calling successHandler with: ', authenticationInfo);
                        successHandler(authenticationInfo);
                    }
                })
                .catch((error) => {
                    log.debug('doAttemptMasquerade: failure response: ', error);
                    delete localStorage.uuid;
                    delete localStorage.mvrCustomerId;
                    delete sessionStorage.token;
                    delete localStorage.masqueradeUser;
                    dispatch({type: MASQUERADE_FAIL, error});
                    if (typeof failureHandler === 'function') {
                        log.debug('doAttemptMasquerade: failure response inside if: ', error);

                        failureHandler(error);
                    }
                });

        };
    },
    doGetLicences: (customerId) => {
        log.debug('doGetLicences()',customerId);
        return (dispatch, state) => {
            dispatch({type: LICENCES });
            return CUP.getLicences(customerId)
                .then((response) => {
                    log.debug('doGetLicences(): response: ', response);
                    dispatch({type: LICENCES_OK, response: response });

                }).catch((error) => {
                    log.debug('doGetLicences(): error: ', error);
                    dispatch({type: LICENCES_FAIL, error: error });

                });
        };
    },

    doGetRoleByUserId: (userId) => {
      return (dispatch, getState) => {
        dispatch({type: USERROLE_LOAD});
        CUP.getRolesByUserId(userId)
          .then((response) => {
            dispatch({type: USERROLE_LOAD_OK, response: response});
          })
          .catch((error) => {
            dispatch({type: USERROLE_LOAD_FAIL, error});
          });
      };
    },
    doLoadDynamicMenuItems(enableSideNavigation) {
        log.debug('getDynamicMenu()');
        return (dispatch, state) => {
            dispatch({type: USER_DYNAMIC_MENU_LOAD });
            return REST_CLIENT.getDynamicMenu(enableSideNavigation)
                .then((response) => {
                    log.debug('getDynamicMenu(): response: ', response);
                    dispatch({type: USER_DYNAMIC_MENU_OK, response: response });
                    return response;
                }).catch((error) => {
                    log.debug('getDynamicMenu(): error: ', error);
                    dispatch({type: USER_DYNAMIC_MENU_FAIL, error: error });
                    return [];
                });
        };
    },

    /**
     * Loads the tenant's paid-feature entitlements. Fails closed - on error every feature is
     * reported as not entitled, so a paid feature is never shown because of an outage.
     */
    doLoadEntitlements() {
        log.debug('doLoadEntitlements()');
        return (dispatch) => {
            dispatch({type: ENTITLEMENTS_LOAD });
            return REST_CLIENT.getEntitlements()
                .then((response) => {
                    log.debug('doLoadEntitlements(): response: ', response);
                    dispatch({type: ENTITLEMENTS_OK, response: response?.features || {} });
                    return response;
                }).catch((error) => {
                    log.debug('doLoadEntitlements(): error: ', error);
                    dispatch({type: ENTITLEMENTS_FAIL, error: error });
                    return {};
                });
        };
    }
};

export default API;